import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { selectUserProfile } from '../../features/common/auth/auth-slice';
import { Error404 } from '../../pages/errors';

interface RoleProtectedRouteProps {
  allowedRoles: string[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles }) => {
  const userProfile = useAppSelector(selectUserProfile);

  const hasAccess = userProfile?.roles.some((role) => allowedRoles.includes(role));

  if (!hasAccess) {
    return <Error404 />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
